export const House = {
  ViewDataModel: {},
  DecoViewDataModel: {},
  HouseInfo: {
    HouseName: '',
    TotalArea: 100
  },
  logoUrl: '/textures/logo/logo-en.png',
  // logoUrl: 'https://images.pexels.com/photos/1679615/pexels-photo-1679615.jpeg?cs=srgb&dl=pexels-markus-spiske-1679615.jpg&fm=jpg',
  loginName: 'kanfang123',
  loginPassword: 'rrd2020.',
  decoResourcePrefix: '',
};

window.House = House;
